import * as React from "react";
import { cn } from "@/lib/utils";

// CargoFL ShadCN Library — Skeleton.
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
